

export class EmailTemplateDto implements IEmailTemplateDto {
    id!: number;
    templateName!: string | undefined;
    emailContent!: string | undefined;
    shortCode!: string | undefined;
    isActive!: boolean;

    constructor(data?: IEmailTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.templateName = _data["templateName"];
            this.emailContent = _data["emailContent"];
            this.shortCode = _data["shortCode"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): EmailTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmailTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["templateName"] = this.templateName;
        data["emailContent"] = this.emailContent;
        data["shortCode"] = this.shortCode;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface IEmailTemplateDto {
    id: number;
    templateName: string | undefined;
    emailContent: string | undefined;
    shortCode: string | undefined;
    isActive: boolean;
}

